import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m)),
  standalone: defineAsyncComponent(() => import("/app/src/layouts/standalone.vue").then(m => m.default || m)),
  "with-ordering-app": defineAsyncComponent(() => import("/app/src/layouts/withOrderingApp.vue").then(m => m.default || m))
}